import React from 'react';
import { Link } from 'react-router-dom';
import { PipelineDiagram } from '../components/PipelineDiagram';
import { Triage } from '../components/Triage';
import { SeeIt } from '../components/SeeIt';
import { Faq } from '../components/Faq';
import { CtaBand } from '../components/CtaBand';
import { Ledger } from '../components/Ledger';
import { LibraryChart } from '../components/LibraryChart';
import { ReworkChart } from '../components/how/ReworkChart';
import { PAYOFF } from '../data/payoff';
export function Index() {
  return <>
      <header className="hero" data-id="element-547" data-mp="3vws81fvyy9d7">
        <div className="hgrid" data-id="element-548" data-mp="3vte5a6je7y58">
          <div className="col-l" data-id="element-549" data-mp="dhhnsp5y4u2t">
            <div className="lab-row" data-id="element-550" data-mp="dispmjftzrra">
              <span className="clabel" data-id="element-551" data-mp="8qhsfoch6k2f">The Instruction Layer</span>
            </div>
            <div className="head-block" data-id="element-552" data-mp="8oojg2ee3nr9">
              <h1 style={{
              fontSize: 'clamp(34px,4.35vw,54px)',
              lineHeight: 1.06,
              maxWidth: '21ch'
            }} data-id="element-553" data-mp="3h5ja8jhwxhoz">
                Your best judgment. Built into every answer that matters.
              </h1>
            </div>
            <div className="sub-block" data-id="element-554" data-mp="1uvv48rzkhdfn">
              <p className="sub" data-id="element-555" data-mp="1uv28em25c8ca">
                Synthia brings together what AI needs to honor &mdash; your policies and expertise, regulatory
                requirements, and industry guidance &mdash; and turns it into instruction data any model can act on{' '}
                <strong style={{
                color: 'var(--ink)'
              }} data-id="element-556" data-mp="29kho97052td7">before it answers</strong>. What&rsquo;s binding goes first. A
                receipt proves what the model was told.
              </p>
              <p className="kicker" data-id="element-557" data-mp="1gxwujzw6y56h">Retrieval degrades gracefully. Obligations don&rsquo;t.</p>
              <div className="ctas" data-id="element-558" data-mp="1lv5cbzdfg777">
                <a className="btn g" href="#see-it" data-id="element-559" data-mp="1lyb4xol9lr7o">
                  See it in action &darr;
                </a>
                <Link className="btn o" to="/contact" data-id="element-560" data-mp="2xbdlijnd6gru">
                  Bring your highest standards &rarr;
                </Link>
              </div>
            </div>
          </div>
          <div className="col-r" data-id="element-561" data-mp="31f1sb04698c1">
            <PipelineDiagram data-id="element-562" data-mp="127paks3y2rvr" />
          </div>
        </div>
      </header>

      <div className="split" data-id="element-563" data-mp="12a1rr31voy7r">
        <div className="sp-l" data-id="element-564" data-mp="x9nk3m46vqa9">
          <span className="clabel" data-id="element-565" data-mp="x8m3z38bgdlo">Who it's for</span>
          <h2 style={{
          maxWidth: 'none',
          fontSize: 'clamp(23px,2.75vw,34px)'
        }} data-id="element-566" data-mp="1b8n4uiokzl15">
            When AI speaks for
            <br data-id="element-567" data-mp="169kapta52z7y" />
            your business, the answer
            <br data-id="element-568" data-mp="167prqkifhh6i" />
            becomes the record.
          </h2>
          <p className="lede" data-id="element-569" data-mp="il12fdr3amfv">
            Ask it &ldquo;what&rsquo;s the capital of France?&rdquo; and there&rsquo;s nothing to record. Find
            &ldquo;Paris.&rdquo; Display &ldquo;Paris.&rdquo; But the moment your AI drafts the denial letter, answers
            the regulator, or approves the claim, the output stops describing your business and starts{' '}
            <strong data-id="element-570" data-mp="3vym8wh2i99yh">committing</strong> it.
          </p>
          <p className="lede" style={{
          marginTop: 14
        }} data-id="element-571" data-mp="3vx1f4to0lv1o">
            And the costly moments are the unscripted ones&mdash;the one-off email no template covers, the reply to an
            auditor nobody drafted in advance. You can&rsquo;t prewrite every consequential moment.
          </p>
          <p className="kicker" data-id="element-572" data-mp="2ba0bjtzr5g5c">
            Synthia gives AI the instructions
            <br data-id="element-573" data-mp="1xilrrky0tax8" />
            that moment requires.
          </p>
        </div>
        <div className="sp-r" data-id="element-574" data-mp="22fm062icepri">
          <Triage data-id="element-575" data-mp="22gx0ttghrhee" />
        </div>
      </div>

      <div className="statband" data-id="element-576" data-mp="2q698uq031jf4">
        <div data-id="element-577" data-mp="2q716s7h5jt8k">
          <div className="bignum" data-id="element-578" data-mp="2q6hnonfrmysy">68%</div>
          <div className="bignum-lab" data-id="element-579" data-mp="2u7l00zylucpf">Adherence at high density</div>
        </div>
        <div data-id="element-580" data-mp="2u5gxalcfzjqq">
          <h2 data-id="element-581" data-mp="2g7sedj1xqmob">
            68% adherence isn&rsquo;t a benchmark. <span data-id="element-582" data-mp="2g7aaq1cy166d">It&rsquo;s a liability.</span>
          </h2>
          <p className="lede" data-id="element-583" data-mp="2l6dfdkp0hadt">
            At high instruction density, even the best AI model tested missed nearly one in three instructions.
            <span style={{
            color: '#C2543C',
            fontWeight: 700,
            fontSize: '1.4em',
            lineHeight: 0,
            verticalAlign: '-0.14em'
          }} data-id="element-584" data-mp="14r27dxpotqtn">
              *
            </span>{' '}
            In business, the missing obligation could be a style preference &mdash; or the disclosure that keeps you
            compliant.
          </p>
          <p className="fnote" data-id="element-585" data-mp="1ba89ua58k2jl">
            <span style={{
            color: '#C2543C'
          }} data-id="element-586" data-mp="1bb16giahdbo0">*</span>{' '}
            <a href="https://arxiv.org/abs/2507.11538" target="_blank" rel="noopener noreferrer" data-id="element-587" data-mp="2808t5tmu5qti">
              IFScale, &ldquo;How Many Instructions Can LLMs Follow at Once?&rdquo;
            </a>{' '}
            At high density, the best-performing frontier model achieved 68% accuracy.
          </p>
        </div>
      </div>

      <div className="split split-seeit" id="see-it" data-id="element-588" data-mp="1u194wn38jdxv">
        <div className="sp-l" data-id="element-589" data-mp="1u2u1ei9416yd">
          <span className="clabel" data-id="element-590" data-mp="nkx56hkrlo06">See it</span>
          <h2 data-id="element-591" data-mp="nlp0rsed3lqg">
            Eleven words.
            <br data-id="element-592" data-mp="ilkh5ti5qaw0" />
            <span className="g" data-id="element-593" data-mp="il1axa1vdaxt">Years of judgment.</span>
          </h2>
          <p className="lede" style={{
          maxWidth: '50ch'
        }} data-id="element-594" data-mp="8hdyb7o5417e">
            A simple request carries more than it says. Hover over the underlined words to discover the expertise and
            obligations behind the answer &mdash; Synthia seats them along with the prompt{' '}
            <strong data-id="element-595" data-mp="idgvs081rbo0">before the model&nbsp;answers</strong>.
          </p>
        </div>
        <div className="sp-r" data-id="element-596" data-mp="n7tlgs049j87">
          <SeeIt data-id="element-597" data-mp="r7vmcyy128mf" />
        </div>
      </div>

      <div className="split" data-id="element-598" data-mp="r6tzzybk9zpe">
        <div className="sp-l" data-id="element-599" data-mp="r7lrawy4lb9v">
          <span className="clabel" data-id="element-600" data-mp="w6ooxwbs0f7t">The rework tax</span>
          <h2 style={{
          maxWidth: '26ch'
        }} data-id="element-601" data-mp="w5doa5dmnnkx">
            The most expensive token
            <br data-id="element-602" data-mp="117cpp9pt4af8" />
            <span className="g" data-id="element-603" data-mp="116t6zqsc1i05">is the correction.</span>
          </h2>
          <p className="lede" data-id="element-604" data-mp="164347slyqxyj">
            A missed fact costs a follow-up question. A missed obligation costs a rework loop, a compliance review, a
            customer apology &mdash; every downstream token spent undoing the first pass.
          </p>
          <p className="lede" style={{
          marginTop: 14
        }} data-id="element-605" data-mp="37yc4by8e9gfc">
            A missing disclosure doesn&rsquo;t <strong data-id="element-606" data-mp="2zxmo1zr758oq">partially comply</strong> &mdash; it&rsquo;s absent, and the
            absence is the incident.
          </p>
          <p className="kicker" data-id="element-607" data-mp="39uimfcndsefk">
            The loop buys fidelity by the token.
            <br data-id="element-608" data-mp="34uwbj9v0za9x" />
            The seat buys it once.
          </p>
        </div>
        <div className="sp-r" data-id="element-609" data-mp="34wzbompw6jsd">
          <ReworkChart data-id="element-610" data-mp="3iue0bp8bmnja" />
        </div>
      </div>

      <div className="stoprow" data-id="element-611" data-mp="3it2wjpevlfs6">
        <div data-id="element-612" data-mp="3dvkpk4kf5amt">
          <span className="clabel" data-id="element-613" data-mp="3dvuio10rfxwq">The payoff</span>
          <h2 style={{
          marginTop: 18
        }} data-id="element-614" data-mp="3dvaxmbftcteh">What changes.</h2>
        </div>
      </div>

      <div className="grid4" data-id="element-615" data-mp="3sj5snyhan9uq">
        {PAYOFF.map(p => <div className="cell" key={p.n} data-id="element-616" data-mp="3nlnnmj6edes0">
            <span className="gnum" aria-hidden="true" data-id="element-617" data-mp="3nlw38itwmy6w">
              {p.n}
            </span>
            <div className="lab" data-id="element-618" data-mp="5gkfepl4wmnd">
              <span data-id="element-619" data-mp="5der3ckbxosp">{p.lab}</span>
            </div>
            <h3 data-id="element-620" data-mp="1f7aqits2pi1">{p.title}</h3>
            <p data-id="element-621" data-mp="1g0inn4h3l1r">{p.body}</p>
          </div>)}
      </div>

      <div className="quoteband" data-id="element-622" data-mp="k3j6ukjzrh23">
        <p data-id="element-623" data-mp="k39if1elhhyi">
          Models will misbehave in ways nobody has named yet.
          <br data-id="element-624" data-mp="p09o3b7j8ip3" />
          When one does, the first question is always the same:
          <br data-id="element-625" data-mp="b2l03ui64vft" />
          <span className="q" data-id="element-626" data-mp="b104s2o158gw">what was it told?</span>
        </p>
      </div>

      <section className="keep" data-id="element-627" data-mp="g03cxvzb3ut3">
        <div className="keep-grid" data-id="element-628" data-mp="fzbgkixvxt1r">
          <div className="keep-copy" data-id="element-629" data-mp="1byt2ooipd8q">
            <span className="clabel" data-id="element-630" data-mp="1axe494ds6lq">What you keep</span>
            <h2 data-id="element-631" data-mp="62ovbt1nczz7">
              The only part of your AI stack that appreciates.
            </h2>
            <p className="lede" data-id="element-632" data-mp="3ogodqphsbhl4">
              It&rsquo;s the judgment your company has built through years of doing the work. Knowing what matters.
              Recognizing the exception. Understanding what a policy means when a customer is waiting for an answer.
            </p>
            <p className="lede" data-id="element-633" data-mp="3eklcrmyo5ozr">
              Synthia turns that expertise into <strong data-id="element-634" data-mp="3jga4j44g61li">a library of instruction data</strong> you own and can keep
              improving.
            </p>
            <p className="kicker" data-id="element-635" data-mp="2tfijfxa917y">
              Change the model.
              <br data-id="element-636" data-mp="3u1l0mfag19y3" />
              Keep the judgment.
            </p>
            <p style={{
            marginTop: 22
          }} data-id="element-637" data-mp="3pyoc67y82jm8">
              <Link className="il" to="/how" data-id="element-638" data-mp="3pxlkvywzmf5s">
                See how it works →
              </Link>
            </p>
          </div>
          <div className="keep-art" data-id="element-639" data-mp="3l1y1k056sg87">
            <div data-id="element-640" data-mp="3g1a5v160jb7n">
              <LibraryChart data-id="element-641" data-mp="3g1sb2nankzrp" />
            </div>
          </div>
        </div>
      </section>

      <div className="stoprow" data-id="element-642" data-mp="3b8z9g8ahe7ju">
        <h2 style={{
        maxWidth: 'none'
      }} data-id="element-643" data-mp="3b8pjgkpfs0e5">FAQs</h2>
      </div>

      <Faq data-id="element-644" data-mp="36a5x4j6xkml9" />

      <CtaBand data-id="element-645" data-mp="36bqojzxy7pew" />
      <Ledger data-id="element-646" data-mp="36b768i4dyz0c" />
    </>;
}